<template>
  <div class="v-toolbar-title">
      <slot/>
  </div>
</template>

<script>

export default {
  name: 'VToolbarTitle',
  props: {
    tag: {
      type: String,
      default: 'div',
    },
  },
};
</script>

<style lang="scss" scoped>
@import "VToolbar";
</style>
